import { Rect } from '../../../platform/geom/Rect';
import { Colors } from '../../../ui';
import { TextSettings } from '../../canvas/entities/TextConventions';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { Shape } from './Shape';
import { ShapeAlgorithm } from './ShapeAlgorithm';

const ShapeContentFieldTextSettings = (shape: Shape) => {
    return TextSettings.from({
        fontFamily: shape.fontFamily,
        fontColor: Colors.normalize(shape.fontColor) ?? shape.getPreferredTextColor(),
        fontWeight: shape.fontWeight,
        fontSize: 0,
        fontStyle: shape.fontStyle,
        lineHeight: 1.25,
        textMargin: shape.textMargin,
        maxFontSize: shape.fontSize,
        textAlignH: shape.textAlignH,
        textAlignV: shape.textAlignV,
    });
};
export const ShapeLayout = (shape: Shape) => {

    const base = new Rect(0, 0, shape.width, shape.height);

    const alg = ShapeAlgorithm.for(shape.kind);
    const cfg = {
        width: shape.width,
        height: shape.height,
        cornerRadius: shape.cornerRadius,
        stroke: shape.stroke,
        style: shape.style,
        color: shape.background,
        sides: shape.sides,
        tail: shape.tail,
    };

    const settings = ShapeContentFieldTextSettings(shape);

    settings.fontSize = Math.min(settings.maxFontSize ?? 1024, TextRuler.fit(
        shape.content,
        settings,
        shape.width,
        shape.height,// hasWidgets ? 92 : 95,
    ));

    const content = { bounds: base, settings, };
    const data = alg(cfg);

    return { base, data, content2: content };
};

export type ShapeLayout = ReturnType<typeof ShapeLayout>;
